import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/display-name
export const StripedTable = forwardRef(
    ({ id = 'striped-table', style, children, ...props }, ref) => {
        return (
            <table
                id={id}
                ref={ref}
                style={{
                    width: 'auto',
                    tableLayout: 'fixed',
                    borderSpacing: 0,
                    padding: 0,
                    backgroundColor: 'rgb(255,255,255)',
                    ...style
                }}
            >
                {children}
            </table>
        );
    }
);

StripedTable.defaultProps = {
    id: 'striped-table'
};

StripedTable.propTypes = {
    id: PropTypes.string,
    style: PropTypes.object,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.object),
        PropTypes.object
    ])
};

export default StripedTable;
